import { http } from '@pendo/http';

export function fetchUsers () {
    return http.get('/api/s/_SID_/user').then((res) => res.data);
}

export function fetchInvitedUsers () {
    return http.get('/api/s/_SID_/invitations').then((res) => res.data);
}

export function fetchUser ({ id, permissionSets }) {
    const queryParams = permissionSets ? '?permissionSets=true' : '';

    return http.get(`/api/s/_SID_/user/${id}${queryParams}`).then((res) => res.data);
}

export function createUser (user) {
    return http.post('/api/s/_SID_/user', user).then((res) => res.data);
}

export function updateUser (user) {
    return http.put(`/api/s/_SID_/user/${user.id}`, user).then((res) => res.data);
}

export function deleteUser ({ id }) {
    return http.delete(`/api/s/_SID_/user/${id}`);
}

export function updateUserFlag (id, { flagName, value }) {
    return http.put(`/api/s/_SID_/user/${id}/flag/${flagName}`, { set: value }).then((res) => res.data);
}

export function updateUserFeatureFlag (id, { flagName, value }) {
    return http.put(`/api/s/_SID_/user/${id}/featureFlag/${flagName}`, { set: value }).then((res) => res.data);
}

export function bulkUpdateFlagForUsers ({ flagName, userIds, set }) {
    return http.put(`/api/s/_SID_/user/flag/${flagName}/bulk`, { set, userIds }).then((res) => res.data);
}

export function updateAdoptManagerFlagAsSuper (id, set, subId = '_SID_') {
    return http.put(`/api/super/s/${subId}/user/${id}/flag/adoptManager`, { set }).then((res) => res.data);
}

export function updateFeedbackVendorUserForUser ({ userId, vendorUserPermissionId, first, last }) {
    return http
        .patch(`/api/s/_SID_/user/${userId}/feedback/vendoruser`, { vendorUserPermissionId, first, last })
        .then((res) => res.data);
}

export function resetPassword (inviteKey, password) {
    return http.post(`/api/signup/user/resetpassword/${inviteKey}`, { password });
}

export function bulkUpdateUserPermissions (updateRequests) {
    return http.put('/api/s/_SID_/user/bulk/permissions', { updateRequests }).then((res) => res.data);
}

export function bulkDeleteUsers (userIds) {
    return http.post('/api/s/_SID_/user/bulk/delete', { users: userIds }).then((res) => {
        if (!res) {
            return [];
        }

        return res.data;
    });
}

export function fetchMinimalUsers () {
    return http
        .get('/api/s/_SID_/users/minimal')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
